import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

// Add icon name here if we will need it in different colors.
// For that purpose as well remove fill property inside svg
const icons = [
  'arrow-up',
  'arrow-down',
  'arrow-right',
  'search',
  'close-thin',
  'icon-close',
  'search-filter',
  'logo',
  'logout',
  'icon-plus-16',
  'delete',
  'clone',
  'icon-status-success',
  'icon-status-error',
  'icon-edit',
  'icon-file',
  'icon_info_24',
  'sparks',
  'icon-send',
  'icon-attach',
  'icon-square',
  'icon-suggestion',
  'launch',
  'exclamation-mark-warning',
];

export default function iconRegister(iconRegistry: MatIconRegistry, sanitizers: DomSanitizer) {
  icons.forEach((svgIcon: string) => {
    iconRegistry.addSvgIcon(svgIcon, sanitizers.bypassSecurityTrustResourceUrl(`assets/icons/${svgIcon}.svg`));
  });
}
